function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.5943 17.6362C20.1349 18.1768 20.1349 19.0538 19.5943 19.5944C19.3239 19.8648 18.9697 19.9999 18.6153 19.9999C18.2608 19.9999 17.9067 19.8648 17.6362 19.5944L11.9999 13.9581L6.36354 19.5944C6.09308 19.8648 5.73896 19.9999 5.3845 19.9999C5.03004 19.9999 4.67592 19.8648 4.40546 19.5944C3.86485 19.0538 3.86485 18.1768 4.40546 17.6362L10.0417 11.9999L4.40546 6.36362C3.86485 5.823 3.86485 4.94608 4.40546 4.40546C4.94638 3.86485 5.82262 3.86485 6.36354 4.40546L11.9999 10.0418L17.6362 4.40546C18.1772 3.86485 19.0534 3.86485 19.5943 4.40546C20.1349 4.94608 20.1349 5.823 19.5943 6.36362L13.958 11.9999L19.5943 17.6362Z",
  fill: "#1F2F53"
});

var SvgIconClose = function SvgIconClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_close.af9f58e3.svg";
export { ForwardRef as ReactComponent };